import {
    cardTitle,
    whiteColor,
} from "assets/jss/material-dashboard-pro-react.js"
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js"

const searchFormStyle = {
    ...customCheckboxRadioSwitch,
    alignCenter: {
        alignItems: "center"
    },
    searchFormWrapper: {
        alignItems: "center",
        marginBottom: "20px"
    },
    searchForm: {
        paddingTop: "0 !important",
        marginBottom: "0 !important"
    },
    buttonWrapper: {
        // alignItems: "center",
        display: "flex",
        // justifyContent: "center",
        marginTop: "16px",
        flex: "unset",
        width: "auto",
        maxWidth: "100%",
        marginLeft: "auto"
    },
    searchLabel: {
        paddingTop: "0 !important"
    },
    marginTop: {
        marginTop: "16px"
    },
    marginRight: {
        marginRight: "16px"
    }
}

export default searchFormStyle
